import React from 'react';
import {List} from "@mui/material";
import {CustomStyleListContainer} from "./Styles";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description List container with dynamic content
 * @param Array<JSX.Element> children: List of JSX elements (required)
 * @param String styleType: Define list style type for every option (required)
 * @returns {JSX.Element}
 */
const CustomListContainer = ({children, styleType=""}) => {

    return (
        <List dense sx={CustomStyleListContainer(styleType)}>
            {children}
        </List>
    );
};

export default CustomListContainer;
